import { memo } from 'react';
import { X, Reply } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { IReplyPreviewProps } from '@/@types/messages';

export const ReplyPreview = memo(function ReplyPreview({
  replyContext,
  onCancel,
}: IReplyPreviewProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-lg bg-muted/50 border border-border px-3 py-2',
        'animate-in slide-in-from-bottom-2 duration-200'
      )}
    >
      <Reply className="size-4 text-foreground shrink-0" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        {replyContext.senderName && (
          <p className="text-xs font-semibold text-foreground truncate">
            {replyContext.senderName}
          </p>
        )}
        <p className="text-xs text-muted-foreground truncate">{replyContext.text ?? 'Media'}</p>
      </div>
      <button
        type="button"
        onClick={onCancel}
        className={cn(
          'shrink-0 rounded-full p-1 text-muted-foreground',
          'hover:bg-accent hover:text-foreground transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
        )}
        aria-label="Cancel reply"
      >
        <X className="size-4" aria-hidden="true" />
      </button>
    </div>
  );
});
